import { useQuery } from '@apollo/client';
import { Button } from '@otp/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StoresByOtpProXlsDocument,
  StoresByOtpProXlsQuery,
} from 'src/graphql/generated/graphql';

export const StoresByOtpProReportButton = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation(undefined, {
    keyPrefix: 'manage-otps',
  });

  const { data } = useQuery<StoresByOtpProXlsQuery>(StoresByOtpProXlsDocument, {
    fetchPolicy: 'network-only',
    skip: !isLoading,
    onCompleted: (data) => {
      setIsLoading(false);
      window.open(data.reportStoresByOtpPro, '_blank');
    },
  });

  const onClick = () => {
    setIsLoading(true);
  };

  return (
    <Button variant="contained" onClick={onClick} disabled={isLoading}>
      {t('stores-by-otp-pro-report-button')}
    </Button>
  );
};
